import { UccAccountObj } from "src/app/app.interfaces";


export function getUccSelectionDialogConfig(data: UccAccountObj) {
    return {
        height: '496px',
        width: '466px',
        panelClass: ['pad-8-dialog', 'dialog-border-radius'],
        disableClose: true,
        data
    };
}

